import { render } from "./AppLayout.vue?vue&type=template&id=34a73860&ts=true"
import script from "./AppLayout.vue?vue&type=script&lang=ts"
export * from "./AppLayout.vue?vue&type=script&lang=ts"

import "./AppLayout.vue?vue&type=style&index=0&id=34a73860&lang=css"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__